import { MaskLines, Eyebrow } from "./Motion";
import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, lines, intro, dark = false, children, testid }) => (
  <section data-testid={testid} className={`relative overflow-hidden ${dark ? "grain bg-[var(--night)] text-white" : "bg-[var(--paper)]"}`}>
    <div className="mx-auto max-w-[1400px] px-5 pb-16 pt-14 md:px-10 md:pb-24 md:pt-20">
      <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
      <h1 className="mt-6 font-display text-[2.6rem] sm:text-5xl lg:text-6xl xl:text-7xl">
        <MaskLines lines={lines} delay={0.1} />
      </h1>
      {intro && (
        <motion.p initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.55, duration: 0.8 }} className={`mt-6 max-w-xl text-base md:text-lg ${dark ? "text-white/80" : "text-[var(--muted-ink)]"}`}>
          {intro}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
